import { useRequest } from '@10000/react'
import { Body, Box, Button, Dialog, H4 } from '../'

export const DeleteTeamDialog = ({ open, onDelete, onClose, id }) => {
  const request = useRequest('tenant')

  const deleteTeam = () => request('teamDeleted', { id }).then(() => onDelete())

  return (
    <Dialog open={open} onClose={onClose} showControls={false} mobileBackground="white" mobileDrawer={false}>
      <H4 color="black">Delete Team</H4>
      <Body color="black">Deleting this team is permanent and all data associated with it will be lost.</Body>
      <Box fullWidth gap={8}>
        <Button fullWidth light onClick={onClose}>Cancel</Button>
        <Button fullWidth onClick={deleteTeam}>Delete</Button>
      </Box>
    </Dialog>
  )
}